<template>
  <div class="">
    <div class="label-standard">
      <RequiredAsterisk v-if="required"></RequiredAsterisk>
      {{ label }}
    </div>

    <div class="form-line">
      <vue-pikaday 
        v-model="localValue" 
        v-on:change="dateChanged($event)"
        class="input-standard"
        :options="dateOptions"
        @blur="dateSelected()" />
    </div>
  </div>
</template>

<script>
  
  import moment           from 'moment'
  import _                from 'lodash'
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type    : Number,
        required: false
      },

      label : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      value : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      index : {
        type    : Number,
        required: false,
      },

      required : {
        type    : Boolean,
        required: false,
        default : false
      },

      // Sometimes, we need to set the default starting date of the
      // calendar. For example, when users select date of birth, if there
      // is no value, we want to take the user to 30 years ago by default
      // Other times we may need to add years
      defaultYearDiff : {
        type : Number,
        required : false
      },

      minDate : {
        type : Date,
        required : false
      },

      maxDate : {
        type : Date,
        required : false
      }

    },

    components: {
      RequiredAsterisk
    },

    // watch : {
    //   'value' : (newValue, oldValue) => {
    //     console.log(newValue, oldValue)
    //   }
    // },

    data() {
      return {
        finalDate : null,
        dateOptions: {
          format     : 'DD/MM/YYYY',
          minDate    : this.minDate != null ? moment(this.minDate, 'YYYY-MM-DD').toDate() : null,
          maxDate    : this.maxDate != null ? moment(this.maxDate, 'YYYY-MM-DD').toDate() : null,
          defaultDate: this.defaultYearDiff != null ? moment().add(this.defaultYearDiff, 'years').toDate() : moment().toDate(),
          yearRange  :100
        }
      }
    },

    computed : {
      localValue : {
        get() {
          return this.value != null ? moment(_.first(this.value.split(" ")), "YYYY-MM-DD").toDate() : null
        },

        set(e) {
          if(e != null && e.target != null) {
            let date = e.target.value
            // console.log(date)
            // console.log(moment(date, 'D/M/YYYY', true).isValid())
            
            // if(date == null || date.length == 0 || moment(date, 'D/M/YYYY', true).isValid()) {
            // if(date == null || date.length == 0) {
            //   this.updateValue({
            //     objectType: this.objectType, 
            //     objectId  : this.objectId,
            //     index     : this.index, 
            //     key       : this.propertyKey, 
            //     value     : null
            //   })
            // }
          }
        }
      }
    },

    methods : {
      dateChanged(e) {
        if(e != null) {
          let value = e.target.value

          this.error = null
          let valid  = true

          if(value != null && value.length > 0) {
            let m = moment(value, 'DD/MM/YYYY').format("YYYY-MM-DD")

            if(m == 'Invalid date') {
              valid = false
            }
          }

          if(valid) {
            this.updateValue({
              objectType: this.objectType, 
              objectId  : this.objectId,
              index     : this.index, 
              key       : this.propertyKey, 
              value     : value != null && value.length > 0 ? moment(value, 'DD/MM/YYYY').format("YYYY-MM-DD") : null
            });
          }
        }
      },

      dateSelected() {
        // console.log(this.finalDate)
        // this.updateValue({
        //   objectType: this.objectType, 
        //   objectId  : this.objectId,
        //   index     : this.index, 
        //   key       : this.propertyKey, 
        //   value     : this.localValue != null ? moment(this.localValue).format("YYYY-MM-DD") : null
        // });
      }
    }
  }
</script>

<style>
  .pika-title select {
    opacity : 1 !important;
  }
</style>